import {
  IFetchQuoteProductDocumentsParams,
  IQuoteProductDocumentPaginatedListData,
  ISetQuoteProductDocumentTagsPayload
} from '@/services/document';
import { IDocumentActions, DocumentContext } from './actions.types';
import {
  IDocumentData,
  IDocumentRevisionData,
  IQuoteDocumentTagData,
  IQuoteProductDocumentData
} from '@/models';

export const actions: IDocumentActions = {
  fetchQuoteProductDocuments(
    context: DocumentContext,
    payload: IFetchQuoteProductDocumentsParams
  ): Promise<void> {
    const promise = this.$services.document.fetchQuoteProductDocuments(payload);
    context.commit('SET_LAST_PROMISE', promise);

    return promise.then((data: IQuoteProductDocumentPaginatedListData) => {
      if (promise == context.state.lastPromise) {
        context.commit('SET_COUNT', data.count);
        context.commit('SET_DOCUMENTS', data.results as IDocumentData[]);
        context.commit('SET_LAST_PROMISE', null);
      }
    });
  },

  fetchQuoteProductDocument(
    context: DocumentContext,
    payload: number
  ): Promise<void> {
    return this.$services.document
      .fetchQuoteProductDocument(payload)
      .then((document: IDocumentData) => {
        const index = context.state.documents.findIndex(
          (v: IDocumentData) => v.id === document.id
        );
        if (index === -1) {
          context.commit('ADD_DOCUMENT', document);
        } else {
          context.commit('UPDATE_DOCUMENT', document);
        }
      });
  },

  createQuoteProductDocument(
    context: DocumentContext,
    payload: IDocumentData
  ): Promise<void> {
    return this.$services.document
      .createQuoteProductDocument(payload)
      .then((document: IDocumentData) => {
        context.commit('ADD_DOCUMENT', document);
      });
  },

  updateQuoteProductDocument(
    context: DocumentContext,
    payload: IDocumentData
  ): Promise<void> {
    return this.$services.document
      .updateQuoteProductDocument(payload)
      .then((document: IDocumentData) => {
        const index = context.state.documents.findIndex(
          (v: IDocumentData) => v.id === document.id
        );
        if (index === -1) {
          context.commit('ADD_DOCUMENT', document);
        } else {
          context.commit('UPDATE_DOCUMENT', document);
        }
      });
  },

  deleteQuoteProductDocument(
    context: DocumentContext,
    payload: number
  ): Promise<void> {
    return this.$services.document
      .deleteQuoteProductDocument(payload)
      .then(() => {
        context.commit('REMOVE_DOCUMENT', payload);
      });
  },

  fetchDocumentRevisions(
    context: DocumentContext,
    payload: number
  ): Promise<void> {
    return this.$services.document
      .fetchDocumentRevisions(payload)
      .then((revision: IDocumentRevisionData[]) => {
        context.commit('SET_DOCUMENT_REVISIONS', revision);
      });
  },

  //Tags
  fetchQuoteDocumentTags(context: DocumentContext): Promise<void> {
    return this.$services.document
      .fetchQuoteDocumentTags()
      .then((documentTags: IQuoteDocumentTagData[]) => {
        context.commit('SET_QUOTE_DOCUMENT_TAGS', documentTags);
      });
  },

  createQuoteDocumentTag(
    context: DocumentContext,
    payload: IQuoteDocumentTagData
  ): Promise<void> {
    return this.$services.document
      .createQuoteDocumentTag(payload)
      .then((tag: IQuoteDocumentTagData) => {
        context.commit('ADD_QUOTE_DOCUMENT_TAG', tag);
      });
  },

  updateQuoteDocumentTag(
    context: DocumentContext,
    payload: IQuoteDocumentTagData
  ): Promise<void> {
    return this.$services.document
      .updateQuoteDocumentTag(payload)
      .then((documentTag: IQuoteDocumentTagData) => {
        const index = context.state.documentTags.findIndex(
          (v: IQuoteDocumentTagData) => v.id === documentTag.id
        );
        if (index === -1) {
          context.commit('ADD_QUOTE_DOCUMENT_TAG', documentTag);
        } else {
          context.commit('UPDATE_QUOTE_DOCUMENT_TAG', documentTag);
        }
      });
  },

  deleteQuoteDocumentTag(
    context: DocumentContext,
    payload: number
  ): Promise<void> {
    return this.$services.document.deleteQuoteDocumentTag(payload).then(() => {
      context.commit('REMOVE_QUOTE_DOCUMENT_TAG', payload);
    });
  },

  setQuoteProductDocumentTags(
    context: DocumentContext,
    payload: ISetQuoteProductDocumentTagsPayload
  ): Promise<void> {
    return this.$services.document
      .setQuoteProductDocumentTags(payload)
      .then((document: IQuoteProductDocumentData) => {
        const index = context.state.documents.findIndex(
          (v: IDocumentData) => v.id === document.id
        );
        if (index === -1) {
          context.commit('ADD_DOCUMENT', document);
        } else {
          context.commit('UPDATE_DOCUMENT', document);
        }
      });
  }
};
